/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'processPortal';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'processPortal';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'processPortal';

/** CoreQueries key with `.paged` / `.item` / `.itemDetail` shape. */
export const FETCH_PARAMS = 'ProcessPortal';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'processPortal';

export const DEFAULT_ORDER_BY = 'name asc';
